import { MetaConversation } from 'lib-shared-legacy-types';
import { User } from 'lib-shared-types-api';

import { ajaxSend } from '../../../../api/api';

// Get queue by id
export function assistedTransferRequest(payload: {
  metaConversation: MetaConversation;
  requestToUser: User;
}) {
  const { metaConversation, requestToUser } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${metaConversation.conversation.id}/transfer/assisted`,
    data: {
      to: requestToUser.id,
    },
  });
}

export function assistedTransferResolve(payload: {
  metaConversation: MetaConversation;
  accepted: boolean;
}) {
  const { metaConversation, accepted } = payload;
  return ajaxSend({
    method: 'PUT',
    path: `/v1/conversations/${metaConversation.conversation.id}/transfer/assisted/resolve`,
    data: {
      accepted: accepted,
    },
  });
}

export function blindTransferRequest(payload: {
  metaConversation: any;
  requestToUser: User;
  message: string | null;
}) {
  const { metaConversation, requestToUser, message } = payload;
  const request = {
    method: 'PUT',
    path: `/v1/conversations/${metaConversation.conversation.id}/transfer/blind`,
    data: {
      to: requestToUser.id,
    },
  };
  if (message && typeof message === 'string' && message.trim().length > 0) {
    (request.data as any).message = message;
  }

  return ajaxSend(request as any);
}
